// Debug configuration
const ENABLE_DEBUG = false;

// Custom logging function
function customLog(message, ...args) {
  if (ENABLE_DEBUG) {
    console.log('product-info --', message, ...args);
  }
}

if (!customElements.get("product-info")) {
    customElements.define(
      "product-info",
      class ProductInfo extends HTMLElement {
        quantityInput = undefined;
        quantityForm = undefined;
        onVariantChangeUnsubscriber = undefined;
        cartUpdateUnsubscriber = undefined;
        abortController = undefined;
        pendingRequestUrl = null;
        preProcessHtmlCallbacks = [];
        postProcessHtmlCallbacks = [];
  
        constructor() {
          super();
          customLog('Constructor called');
          this.quantityInput = this.querySelector(".quantity__input");
          customLog('Quantity input found:', this.quantityInput);
          // this.productPrice = document.querySelector("product-price");
        }
  
        connectedCallback() {
          customLog('Connected callback started');
          this.initializeProductSwapUtility();
          customLog('Product swap utility initialized');

          this.onVariantChangeUnsubscriber = subscribe(
            PUB_SUB_EVENTS.optionValueSelectionChange,
            this.handleOptionValueChange.bind(this)
          );
          customLog('Variant change subscription created');

          this.initQuantityHandlers();
          customLog('Quantity handlers initialized');
          this.dispatchEvent(
            new CustomEvent("product-info:loaded", { bubbles: true })
          );
          customLog('Product info loaded event dispatched');
        }
  
        addPreProcessCallback(callback) {
          this.preProcessHtmlCallbacks.push(callback);
        }
  
        initQuantityHandlers() {
          customLog('Initializing quantity handlers');
          if (!this.quantityInput) {
            customLog('No quantity input found, returning');
            return;
          }

          this.quantityForm = this.querySelector(".product-form__quantity");
          customLog('Quantity form found:', this.quantityForm);
          if (!this.quantityForm) {
            customLog('No quantity form found, returning');
            return;
          }

          this.setQuantityBoundries();
          customLog('Quantity boundaries set');
          if (!this.dataset.originalSection) {
            customLog('Subscribing to cart update events');
            this.cartUpdateUnsubscriber = subscribe(
              PUB_SUB_EVENTS.cartUpdate,
              this.fetchQuantityRules.bind(this)
            );
          }
        }
  
        disconnectedCallback() {
          customLog('Product info disconnected, cleaning up subscriptions');
          this.onVariantChangeUnsubscriber();
          this.cartUpdateUnsubscriber?.();
          customLog('Subscriptions cleaned up');
        }
  
        initializeProductSwapUtility() {
          this.preProcessHtmlCallbacks.push((html) =>
            html
              .querySelectorAll(".scroll-trigger")
              .forEach((element) =>
                element.classList.add("scroll-trigger--cancel")
              )
          );
          this.postProcessHtmlCallbacks.push((newNode) => {
            window?.Shopify?.PaymentButton?.init();
            window?.ProductModel?.loadShopifyXR();
          });
        }
  
        handleOptionValueChange({
          data: { event, target, selectedOptionValues },
        }) {
          customLog('Option value change triggered', { event, target, selectedOptionValues });
          if (!this.contains(event.target)) {
            customLog('Event target not contained in this element, returning');
            return;
          }

          this.resetProductFormState();
          customLog('Product form state reset');

          const productUrl =
            target.dataset.productUrl ||
            this.pendingRequestUrl ||
            this.dataset.url;
          this.pendingRequestUrl = productUrl;
          const shouldSwapProduct = this.dataset.url !== productUrl;
          const shouldFetchFullPage =
            this.dataset.updateUrl === "true" && shouldSwapProduct;
          
          customLog('Product URL determined:', productUrl);
          customLog('Should swap product:', shouldSwapProduct);
          customLog('Should fetch full page:', shouldFetchFullPage);

          this.renderProductInfo({
            requestUrl: this.buildRequestUrlWithParams(
              productUrl,
              selectedOptionValues,
              shouldFetchFullPage
            ),
            targetId: target.id,
            callback: shouldSwapProduct
              ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
              : this.handleUpdateProductInfo(productUrl),
          });
        }
  
        resetProductFormState() {
          customLog('Resetting product form state');
          const productForm = this.productForm;
          customLog('Product form found:', productForm);
          productForm?.toggleSubmitButton(true);
          productForm?.handleErrorMessage();
        }
  
        handleSwapProduct(productUrl, updateFullPage) {
          customLog('Handle swap product called', { productUrl, updateFullPage });
          return (html) => {
            customLog('Swap product callback executing');
            this.productModal?.remove();
            customLog('Product modal removed');

            const selector = updateFullPage
              ? "product-info[id^='MainProduct']"
              : "product-info";
            const variant = this.getSelectedVariant(html.querySelector(selector));
            customLog('Selected variant:', variant);
            this.updateURL(productUrl, variant?.id);
            customLog('URL updated');

            if (updateFullPage) {
              customLog('Updating full page');
              document.querySelector("head title").innerHTML =
                html.querySelector("head title").innerHTML;

              HTMLUpdateUtility.viewTransition(
                document.querySelector("main"),
                html.querySelector("main"),
                this.preProcessHtmlCallbacks,
                this.postProcessHtmlCallbacks
              );
            } else {
              customLog('Updating product info only');
              HTMLUpdateUtility.viewTransition(
                this,
                html.querySelector("product-info"),
                this.preProcessHtmlCallbacks,
                this.postProcessHtmlCallbacks
              );
            }
          };
        }
  
        renderProductInfo({ requestUrl, targetId, callback }) {
          customLog('Render product info called', { requestUrl, targetId });
          this.abortController?.abort();
          this.abortController = new AbortController();
          customLog('Abort controller created');

          fetch(requestUrl, { signal: this.abortController.signal })
            .then((response) => {
              customLog('Fetch response received', response.status);
              return response.text();
            })
            .then((responseText) => {
              customLog('Response text received, length:', responseText.length);
              this.pendingRequestUrl = null;
              const html = new DOMParser().parseFromString(
                responseText,
                "text/html"
              );
              customLog('HTML parsed successfully');
            
              callback(html);
            })
            .then(() => {
              customLog('Callback completed, setting focus to:', targetId);
              // set focus to last clicked option value
              document.querySelector(`#${targetId}`)?.focus();
            })
            .catch((error) => {
              if (error.name === "AbortError") {
                customLog("Fetch aborted by user");
              } else {
                customLog('Fetch error:', error);
                console.error(error);
              }
            });
        }
  
        getSelectedVariant(productInfoNode) {
          customLog('Getting selected variant from node:', productInfoNode);
          const selectedVariant = productInfoNode.querySelector(
            "variant-selects [data-selected-variant]"
          )?.innerHTML;
          customLog('Selected variant HTML:', selectedVariant);
          const parsed = !!selectedVariant ? JSON.parse(selectedVariant) : null;
          customLog('Parsed variant:', parsed);
          return parsed;
        }
  
        buildRequestUrlWithParams(
          url,
          optionValues,
          shouldFetchFullPage = false
        ) {
          customLog('Building request URL with params:', { url, optionValues, shouldFetchFullPage });
          const params = [];

          !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

          if (optionValues.length) {
            params.push(`option_values=${optionValues.join(",")}`);
          }

          const finalUrl = `${url}?${params.join("&")}`;
          customLog('Final request URL:', finalUrl);
          return finalUrl;
        }
  
        updateOptionValues(html) {
          const variantSelects = html.querySelector("variant-selects");
          if (variantSelects) {
            HTMLUpdateUtility.viewTransition(
              this.variantSelectors,
              variantSelects,
              this.preProcessHtmlCallbacks
            );
          }
        }
  
        handleUpdateProductInfo(productUrl) {
          customLog('Handle update product info called for URL:', productUrl);
          console.log('update')
          return (html) => {
            customLog('Update product info callback executing');
            const variant = this.getSelectedVariant(html);
            customLog('Selected variant in update:', variant);

            this.pickupAvailability?.update(variant);
            customLog('Pickup availability updated');
            this.updateOptionValues(html);
            customLog('Option values updated');
            this.updateURL(productUrl, variant?.id);
            customLog('URL updated');
            this.updateVariantInputs(variant?.id);
            customLog('Variant inputs updated');

            if (!variant) {
              customLog('No variant found, setting unavailable');
              this.setUnavailable();
              return;
            }

            this.updateMedia(html, variant?.featured_media?.id);
            customLog('Media updated');
  
            const updateSourceFromDestination = (
              id,
              shouldHide = (source) => false
            ) => {
              const source = html.getElementById(`${id}-${this.sectionId}`);
              const destination = this.querySelector(
                `#${id}-${this.dataset.section}`
              );
              if (source && destination) {
                destination.innerHTML = source.innerHTML;
                destination.classList.toggle("hidden", shouldHide(source));
              }
            };
  
            updateSourceFromDestination("Quantity-discount");
            updateSourceFromDestination("Product-price");
            updateSourceFromDestination("price");
            updateSourceFromDestination("Sku", ({ classList }) =>
              classList.contains("hidden")
            );
            updateSourceFromDestination(
              "Inventory",
              ({ innerText }) => innerText === ""
            );
            updateSourceFromDestination("Volume");
            updateSourceFromDestination("Price-Per-Item", ({ classList }) =>
              classList.contains("hidden")
            );
  
            this.updateQuantityRules(this.sectionId, html);
            this.querySelector(
              `#Quantity-Rules-${this.dataset.section}`
            )?.classList.remove("hidden");
            this.querySelector(
              `#Volume-Note-${this.dataset.section}`
            )?.classList.remove("hidden");
  
            this.productForm?.toggleSubmitButton(
              html.getElementById(`ProductSubmitButton-${this.sectionId}`),
              html
                .getElementById(`ProductSubmitButton-${this.sectionId}`)
                ?.hasAttribute("disabled") ?? true,
              window.variantStrings.soldOut
            );
  
            publish(PUB_SUB_EVENTS.variantChange, {
              data: {
                sectionId: this.sectionId,
                html,
                variant,
              },
            });
          };
        }
  
        updateVariantInputs(variantId) {
          customLog('Updating variant inputs with ID:', variantId);
          const forms = this.querySelectorAll(
            `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
          );
          customLog('Found product forms:', forms.length);
          forms.forEach((productForm, index) => {
            const input = productForm.querySelector('input[name="id"]');
            customLog(`Updating form ${index} input:`, input);
            input.value = variantId ?? "";
            input.dispatchEvent(new Event("change", { bubbles: true }));
            customLog(`Form ${index} input updated and change event dispatched`);
          });
        }
  
        updateURL(url, variantId) {
          this.querySelector("share-button")?.updateUrl(
            `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ""}`
          );
  
          if (this.dataset.updateUrl === "false") return;
          window.history.replaceState(
            {},
            "",
            `${url}${variantId ? `?variant=${variantId}` : ""}`
          );
        }
  
        setUnavailable() {
          customLog('Setting product as unavailable');
          this.productForm?.toggleSubmitButton(
            true,
            window.variantStrings.unavailable
          );
          customLog('Submit button toggled to unavailable');

          const selectors = [
            "price",
            "Inventory",
            "Sku",
            "Price-Per-Item",
            "Volume-Note",
            "Volume",
            "Quantity-Rules",
          ]
            .map((id) => `#${id}-${this.dataset.section}`)
            .join(", ");
          customLog('Hiding elements with selectors:', selectors);
          const elements = document.querySelectorAll(selectors);
          customLog('Found elements to hide:', elements.length);
          elements.forEach(({ classList }) => classList.add("hidden"));
        }
  
        updateMedia(html, variantFeaturedMediaId) {
          customLog('Updating media for variant:', variantFeaturedMediaId);
          if (!variantFeaturedMediaId) {
            customLog('No variant featured media ID, returning');
            return;
          }

          const mediaGallerySource = this.querySelector("media-gallery ul");
          const mediaGalleryDestination = html.querySelector(`media-gallery ul`);
          customLog('Media galleries found:', { mediaGallerySource, mediaGalleryDestination });

          const refreshSourceData = () => {
            customLog('Refreshing source data');
            if (this.hasAttribute("data-zoom-on-hover")) enableZoomOnHover(2);
            const mediaGallerySourceItems = Array.from(
              mediaGallerySource.querySelectorAll("li[data-media-id]")
            );
            const sourceSet = new Set(
              mediaGallerySourceItems.map((item) => item.dataset.mediaId)
            );
            const sourceMap = new Map(
              mediaGallerySourceItems.map((item, index) => [
                item.dataset.mediaId,
                { item, index },
              ])
            );
            customLog('Source data refreshed:', { itemsCount: mediaGallerySourceItems.length, sourceSetSize: sourceSet.size });
            return [mediaGallerySourceItems, sourceSet, sourceMap];
          };
  
          if (mediaGallerySource && mediaGalleryDestination) {
            customLog('Both media galleries found, processing updates');
            let [mediaGallerySourceItems, sourceSet, sourceMap] =
              refreshSourceData();
            const mediaGalleryDestinationItems = Array.from(
              mediaGalleryDestination.querySelectorAll('li[data-media-id]')
            );
            const destinationSet = new Set(
              mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId)
            );
            customLog('Destination items count:', mediaGalleryDestinationItems.length);
            let shouldRefresh = false;
  
            // add items from new data not present in DOM
            customLog('Adding new items to DOM');
            for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
              if (
                !sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)
              ) {
                customLog('Adding new media item:', mediaGalleryDestinationItems[i].dataset.mediaId);
                mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
                shouldRefresh = true;
              }
            }
  
            // remove items from DOM not present in new data
            customLog('Removing old items from DOM');
            for (let i = 0; i < mediaGallerySourceItems.length; i++) {
              if (
                !destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)
              ) {
                customLog('Removing old media item:', mediaGallerySourceItems[i].dataset.mediaId);
                mediaGallerySourceItems[i].remove();
                shouldRefresh = true;
              }
            }
  
            // refresh
            if (shouldRefresh) {
              customLog('Refreshing source data after changes');
              [mediaGallerySourceItems, sourceSet, sourceMap] =
                refreshSourceData();
            }

            // if media galleries don't match, sort to match new data order
            customLog('Sorting media items to match new order');
            mediaGalleryDestinationItems.forEach(
              (destinationItem, destinationIndex) => {
                const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

                if (sourceData && sourceData.index !== destinationIndex) {
                  customLog(`Moving media item ${destinationItem.dataset.mediaId} to position ${destinationIndex}`);
                  mediaGallerySource.insertBefore(
                    sourceData.item,
                    mediaGallerySource.querySelector(
                      `li:nth-of-type(${destinationIndex + 1})`
                    )
                  );

                  // refresh source now that it has been modified
                  [mediaGallerySourceItems, sourceSet, sourceMap] =
                    refreshSourceData();
                }
              }
            );
          }
  
          // set featured media as active in the media gallery
          customLog('Setting active media:', `${this.dataset.section}-${variantFeaturedMediaId}`);
          this.querySelector(`media-gallery`)?.setActiveMedia?.(
            `${this.dataset.section}-${variantFeaturedMediaId}`,
            true
          );

          // update media modal
          customLog('Updating media modal content');
          const modalContent = this.productModal?.querySelector(
            `.product-media-modal__content`
          );
          const newModalContent = html.querySelector(
            `product-modal .product-media-modal__content`
          );
          customLog('Modal content elements:', { modalContent, newModalContent });
          if (modalContent && newModalContent) {
            modalContent.innerHTML = newModalContent.innerHTML;
            customLog('Modal content updated');
          }
        }
  
        setQuantityBoundries() {
          customLog('Setting quantity boundaries');
          const data = {
            cartQuantity: this.quantityInput.dataset.cartQuantity
              ? parseInt(this.quantityInput.dataset.cartQuantity)
              : 0,
            min: this.quantityInput.dataset.min
              ? parseInt(this.quantityInput.dataset.min)
              : 1,
            max: this.quantityInput.dataset.max
              ? parseInt(this.quantityInput.dataset.max)
              : null,
            step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
          };
          customLog('Quantity data:', data);

          let min = data.min;
          const max = data.max === null ? data.max : data.max - data.cartQuantity;
          if (max !== null) min = Math.min(min, max);
          if (data.cartQuantity >= data.min) min = Math.min(min, data.step);
          customLog('Calculated min/max:', { min, max });

          this.quantityInput.min = min;

          if (max) {
            this.quantityInput.max = max;
          } else {
            this.quantityInput.removeAttribute("max");
          }
          this.quantityInput.value = min;
          customLog('Quantity input updated:', { min, max, value: this.quantityInput.value });

          publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
        }
  
        fetchQuantityRules() {
          customLog('Fetching quantity rules');
          const currentVariantId = this.productForm?.variantIdInput?.value;
          customLog('Current variant ID:', currentVariantId);
          if (!currentVariantId) {
            customLog('No variant ID found, returning');
            return;
          }

          this.querySelector(
            ".quantity__rules-cart .loading__spinner"
          ).classList.remove("hidden");
          customLog('Loading spinner shown');
          
          const fetchUrl = `${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`;
          customLog('Fetching from URL:', fetchUrl);
          
          fetch(fetchUrl)
            .then((response) => {
              customLog('Quantity rules response received:', response.status);
              return response.text();
            })
            .then((responseText) => {
              customLog('Quantity rules response text received, length:', responseText.length);
              const html = new DOMParser().parseFromString(
                responseText,
                "text/html"
              );
              this.updateQuantityRules(this.dataset.section, html);
            })
            .catch((e) => {
              customLog('Error fetching quantity rules:', e);
              console.error(e);
            })
            .finally(() => {
              customLog('Quantity rules fetch completed, hiding spinner');
              this.querySelector(
                ".quantity__rules-cart .loading__spinner"
              ).classList.add("hidden");
            });
        }
  
        updateQuantityRules(sectionId, html) {
          customLog('Updating quantity rules for section:', sectionId);
          if (!this.quantityInput) {
            customLog('No quantity input found, returning');
            return;
          }
          this.setQuantityBoundries();

          const quantityFormUpdated = html.getElementById(
            `Quantity-Form-${sectionId}`
          );
          customLog('Updated quantity form found:', quantityFormUpdated);
          
          const selectors = [
            ".quantity__input",
            ".quantity__rules",
            ".quantity__label",
          ];
          for (let selector of selectors) {
            const current = this.quantityForm.querySelector(selector);
            const updated = quantityFormUpdated.querySelector(selector);
            customLog(`Processing selector ${selector}:`, { current, updated });
            if (!current || !updated) continue;
            if (selector === ".quantity__input") {
              const attributes = [
                "data-cart-quantity",
                "data-min",
                "data-max",
                "step",
              ];
              for (let attribute of attributes) {
                const valueUpdated = updated.getAttribute(attribute);
                if (valueUpdated !== null) {
                  current.setAttribute(attribute, valueUpdated);
                  customLog(`Updated attribute ${attribute} to:`, valueUpdated);
                } else {
                  current.removeAttribute(attribute);
                  customLog(`Removed attribute ${attribute}`);
                }
              }
            } else {
              current.innerHTML = updated.innerHTML;
              customLog(`Updated innerHTML for ${selector}`);
            }
          }
        }
  
        get productForm() {
          return this.querySelector(`product-form`);
        }
  
        get productModal() {
          return document.querySelector(`#ProductModal-${this.dataset.section}`);
        }
  
        get pickupAvailability() {
          return this.querySelector(`pickup-availability`);
        }
  
        get variantSelectors() {
          return this.querySelector("variant-selects");
        }
  
        get relatedProducts() {
          const relatedProductsSectionId = SectionId.getIdForSection(
            SectionId.parseId(this.sectionId),
            "related-products"
          );
          return document.querySelector(
            `product-recommendations[data-section-id^="${relatedProductsSectionId}"]`
          );
        }
  
        get quickOrderList() {
          const quickOrderListSectionId = SectionId.getIdForSection(
            SectionId.parseId(this.sectionId),
            "quick_order_list"
          );
          return document.querySelector(
            `quick-order-list[data-id^="${quickOrderListSectionId}"]`
          );
        }
  
        get sectionId() {
          return this.dataset.originalSection || this.dataset.section;
        }
      }
    );
  }
  
  
  if (!customElements.get("product-price")) {
    customElements.define(
      "product-price",
      class ProductPrice extends HTMLElement {
        constructor() {
          super();
          customLog('ProductPrice constructor called');
          this.container = this.querySelector('.price__container');
          this.savingsContainer = this.querySelector('.product__price-savings');
          this.quantityInput = document.querySelector("quantity-input");
          this.isQuantityDiscount = this.dataset.isquantity == "true";
          this.quantityTwoDiscount = 1 - (parseInt(this.dataset.quantityTwo)/100);
          this.quantityFourDiscount = 1 - (parseInt(this.dataset.quantityFour)/100);
          this.comparePriceLabel = this.querySelector('[data-compare-price-label]');
          this.priceLabel = this.querySelector('[data-price-label]');
          customLog('ProductPrice elements found:', {
            container: this.container,
            savingsContainer: this.savingsContainer,
            quantityInput: this.quantityInput,
            isQuantityDiscount: this.isQuantityDiscount,
            quantityTwoDiscount: this.quantityTwoDiscount,
            quantityFourDiscount: this.quantityFourDiscount
          });
          // this.updatePrice(1);
          window.onIgReady = [() => this.updatePrice(1)];
        }


        
        async updatePrice(e) {

  function _waitForElement(selector, delay = 50, tries = 100) {
    const element = document.querySelector(selector);

    if (!window[`__${selector}`]) {
      window[`__${selector}`] = 0;
      window[`__${selector}__delay`] = delay;
      window[`__${selector}__tries`] = tries;
    }

    function _search() {
      return new Promise((resolve) => {
        window[`__${selector}`]++;
        setTimeout(resolve, window[`__${selector}__delay`]);
      });
    }

    if (element === null) {
      if (window[`__${selector}`] >= window[`__${selector}__tries`]) {
        window[`__${selector}`] = 0;
        return Promise.resolve(null);
      }

      return _search().then(() => _waitForElement(selector));
    } else {
      return Promise.resolve(element);
    }
  }


          customLog('ProductPrice updatePrice called with quantity:', e);
          console.log("ak - update price", e);

      
           // Get variant from URL query string
           const urlParams = new URLSearchParams(window.location.search);
           const variant = urlParams.get('variant') || this.container.dataset.currentVariant;
           customLog('Variant from URL:', variant);

           var $container = await _waitForElement(`.price__container[data-current-variant]`)

          let igPrice = igData.price.getPriceByVariantId(variant);
          let igComparePrice = igData.price.getComparePriceByVariantId(variant);
          let rawPrice = $container.dataset.price;
          let rawComparePrice = $container.dataset.comparePrice;
          customLog('Initial prices:', { igPrice, igComparePrice, rawPrice, rawComparePrice });
     
    
          if (igPrice) {
            igPrice = (parseFloat(igPrice)*100).toString();
            rawPrice = igPrice;
            customLog('IG price applied:', rawPrice);
          }
          if (igComparePrice) {
            igComparePrice = (parseFloat(igComparePrice)*100).toString();
            rawComparePrice = igComparePrice;
            customLog('IG compare price applied:', rawComparePrice);
          }
          console.log("ak discount", rawPrice, this.quantityTwoDiscount, rawComparePrice);
          let multiplier = 1;
          if(this.isQuantityDiscount) {
            customLog('Applying quantity discount for quantity:', e);
            if (e >= 4) {
              customLog('Applying 4+ quantity discount:', this.quantityFourDiscount);
              // rawComparePrice = rawPrice;
              rawPrice = rawPrice * this.quantityFourDiscount;
              multiplier = e * this.quantityFourDiscount; 
            } else if(e >= 2) {
              customLog('Applying 2+ quantity discount:', this.quantityTwoDiscount);
              // rawComparePrice = rawPrice;
              rawPrice = rawPrice * this.quantityTwoDiscount; 
              multiplier = e * this.quantityTwoDiscount;
            } 
            customLog('Final prices after discount:', { rawPrice, rawComparePrice });
            // else {
            //   rawPrice = this.container.dataset.price;
            //   rawComparePrice = this.container.dataset.comparePrice;
            // }
          }
          
          
          // =======PRICE=======
          customLog('Updating price display');
          const $priceLabel = document.querySelector(`product-price[id] [data-price-label] `)
          customLog('Price label element:', $priceLabel);

    
          const newPrice = e * rawPrice;
          const price = (newPrice / 100).toFixed(2);
          customLog('Calculated price:', { newPrice, price });

          $priceLabel.textContent = this.formatPrice(price);
          $priceLabel.dataset.priceMultiplier = multiplier;
          $priceLabel.dataset.variantId = variant;
          
          // =======COMPARE PRICE=======
          customLog('Updating compare price display');
          const $comparePriceLabel = document.querySelector(`product-price[id] [data-compare-price-label] `)
          customLog('Compare price label element:', $comparePriceLabel);
          const newComparePrice = e * rawComparePrice;
          const comparePrice = (newComparePrice / 100).toFixed(2);

          customLog('Calculated compare price:', { newComparePrice, comparePrice });
     

          
          $comparePriceLabel.textContent = comparePrice <= 0 ? "" : this.formatPrice(comparePrice);
          $comparePriceLabel.dataset.priceMultiplier = e;
          customLog('Price labels updated');

          this.updateSavings(comparePrice, price);
          
        }
  
        updateSavings(comparePrice, currentPrice) {
          console.log('Updating savings display:', { comparePrice, currentPrice });
          comparePrice = parseFloat(comparePrice);
          currentPrice = parseFloat(currentPrice);
          if (comparePrice <= currentPrice) {
            console.log('No savings to show, hiding container');
            var savingsContainer = document.querySelector('.product__price-savings');
            savingsContainer?.classList.add('hidden');
            return;
          }
        
          const savings = ((comparePrice - currentPrice) / comparePrice) * 100;
          const rounded = Math.round(savings);
          console.log('Calculated savings:', { savings, rounded });

          var savingsContainer = document.querySelector('.product__price-savings');
        
          if (savingsContainer) {
            savingsContainer.classList.remove('hidden');
            savingsContainer.textContent = `${rounded}% OFF`;
            console.log('Savings container updated with:', `${rounded}% OFF`);
          }
        }
  
        
  
formatPrice(price) {
  customLog('Formatting price:', price);

  const money = this.container.dataset.money;
  let formatted;

  if (money.includes('€')) { // Euro
    formatted = money.replace('0,00', price);
  } else if (money.includes('$')) { // US Dollar, AUD, CAD, etc.
    formatted = money.replace('0.00', price);
  } else if (money.includes('£')) { // British Pound
    formatted = money.replace('0.00', price);
  } else if (money.includes('R$')) { // Brazilian Real
    formatted = money.replace('0,00', price);
  } else if (money.includes('¥')) { // Japanese Yen, Chinese Yuan
    formatted = money.replace('0.00', price);
  } else if (money.includes('₣')) { // Swiss Franc (older symbol)
    formatted = money.replace('0.00', price);
  } else if (money.includes('₽')) { // Russian Ruble
    formatted = money.replace('0,00', price);
  } else if (money.includes('₩')) { // Korean Won
    formatted = money.replace('0.00', price);
  } else if (money.includes('₹')) { // Indian Rupee
    formatted = money.replace('0.00', price);
  } else if (money.includes('₺')) { // Turkish Lira
    formatted = money.replace('0,00', price);
  } else if (money.includes('CHF')) { // Swiss Franc
    formatted = money.replace('0.00', price);
  } else if (money.includes('HK$')) { // Hong Kong Dollar
    formatted = money.replace('0.00', price);
  } else if (money.includes('NZ$')) { // New Zealand Dollar
    formatted = money.replace('0.00', price);
  } else if (money.includes('SG$')) { // Singapore Dollar
    formatted = money.replace('0.00', price);
  } else if (money.includes('kr')) { // Swedish Krona, Norwegian Krone, Danish Krone
    formatted = money.replace('0,00', price);
  } else if (money.includes('₫')) { // Vietnamese Dong
    formatted = money.replace('0.00', price);
  } else if (money.includes('₪')) { // Israeli Shekel
    formatted = money.replace('0.00', price);
  } else {
    // Default fallback
    formatted = money.replace('0.00', price);
  }

  customLog('Formatted price:', formatted);
  return formatted;
}

      }
    )
  }